import { ObjectSelectField } from '../../../components/form/model';
import WorkQueue from '../model/WorkQueue';
import ko from 'knockout';

ko.bindingHandlers['workqueue'] = {
	init(element, valueAccessor, allBindingsAccessor, viewModel: ObjectSelectField) {
		var value = valueAccessor();
		var hasActiveIndirect = viewModel.form.findField('HasActiveIndirect');
		let stateField = viewModel.form.findField('OperationState');

		var workQueue = ko.computed(() =>
			new WorkQueue(value(), stateField, hasActiveIndirect && hasActiveIndirect.value())
		);

		ko.applyBindingsToDescendants(workQueue, element);

		return { controlsDescendantBindings: true };
	}
}
